export default __webpack_public_path__ + "static/media/27_photo.3f1450d6.jpeg";